(function() {
var OmsInfiniteScroll,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

OmsInfiniteScroll = (function() {
  function OmsInfiniteScroll(container_id) {
    this.load_more_items = bind(this.load_more_items, this);
    this.delete_item = bind(this.delete_item, this);
    this.replace_item = bind(this.replace_item, this);
    this.insert_item = bind(this.insert_item, this);
    this.process_intersection_entries = bind(this.process_intersection_entries, this);
    this.determine_load_more = bind(this.determine_load_more, this);
    this.stop_observing = bind(this.stop_observing, this);
    this.start_observing = bind(this.start_observing, this);
    var _pusher_channel, _pusher_key, options;
    console.log("OmsInfiniteScroll constructor");
    this.container = $("#" + container_id);
    this.items_container = this.container.find('[data-infinite-scroll-items-container]:first');
    this.load_more_container = this.container.find('[data-infinite-scroll-load-more-container]:first');
    console.log("items container is: ");
    console.log(this.items_container);
    console.log("load more container is: ");
    console.log(this.load_more_container);
    _pusher_channel = this.items_container.data("infinite-scroll-feed-channel");
    if (_pusher_channel != null) {
      _pusher_key = this.items_container.data("pusher-key");
      this.pusher = new Pusher(_pusher_key, {
        cluster: "eu"
      });
      this.channel = this.pusher.subscribe(_pusher_channel);
      this.pusher.connection.bind('connected', (function(_this) {
        return function() {};
      })(this));
      this.channel.bind('new_item', (function(_this) {
        return function(data) {
          return _this.insert_item(data.item);
        };
      })(this));
      this.channel.bind('update_item', (function(_this) {
        return function(data) {
          console.log("update_item from pusher: data is");
          console.log(data);
          return _this.replace_item(data.item, data.id);
        };
      })(this));
      this.channel.bind('delete_item', (function(_this) {
        return function(data) {
          console.log("delete_item from pusher: data is");
          console.log(data);
          return _this.delete_item(data.id);
        };
      })(this));
    }
    options = {
      rootMargin: '10px'
    };
    this.intesection_observer = new IntersectionObserver(((function(_this) {
      return function(entries) {
        return _this.process_intersection_entries(entries);
      };
    })(this)), options);
    this.determine_load_more();
    this.start_observing();
  }

  OmsInfiniteScroll.prototype.start_observing = function() {
    return this.intesection_observer.observe(this.load_more_container.get(0));
  };

  OmsInfiniteScroll.prototype.stop_observing = function() {
    return this.intesection_observer.unobserve(this.load_more_container.get(0));
  };

  OmsInfiniteScroll.prototype.determine_load_more = function() {
    this.load_more_control = this.container.find('[data-infinite-scroll-load-more]:first');
    return this.load_more = this.load_more_control.data("infinite-scroll-load-more") === true;
  };

  OmsInfiniteScroll.prototype.process_intersection_entries = function(entries) {
    var entry, i, len, results;
    results = [];
    for (i = 0, len = entries.length; i < len; i++) {
      entry = entries[i];
      if (entry.isIntersecting) {
        results.push(this.load_more_items());
      } else {
        results.push(void 0);
      }
    }
    return results;
  };

  OmsInfiniteScroll.prototype.insert_item = function(item_html) {
    var _new_element;
    this.items_container.prepend(item_html);
    _new_element = this.items_container.find("div:first");
    return _new_element.hide().slideDown("slow");
  };

  OmsInfiniteScroll.prototype.replace_item = function(item_html, item_id) {
    return this.items_container.find('[data-infinite-scroll-item-id="' + item_id + '"]').replaceWith(item_html);
  };

  OmsInfiniteScroll.prototype.delete_item = function(item_id) {
    return this.items_container.find('[data-infinite-scroll-item-id="' + item_id + '"]').slideUp();
  };

  OmsInfiniteScroll.prototype.load_more_items = function() {
    var url;
    if (!this.load_more) {
      return;
    }
    this.anchor = this.load_more_container.find("a").get(0);
    if (this.anchor == null) {
      return;
    }
    url = this.anchor.href;
    return $.getJSON(url, {}, (function(_this) {
      return function(data) {
        _this.items_container.append(data.entries);
        _this.load_more_control.replaceWith(data.load_more_control);
        return _this.determine_load_more();
      };
    })(this));
  };

  return OmsInfiniteScroll;

})();

window.alpha_oms.oms_infinite_scroll_constructor = OmsInfiniteScroll;

}).call(window);
